import React, { Component } from "react";

import "../CSS/style_ExplanationPage.css";
import LogoBilapp from "../Images/logoBilapp.png";
import LogoBilappe from "../Images/logo_bilapp.png";
import { Grid, Row, Col } from 'react-material-responsive-grid';
import FlatButton         from "material-ui/FlatButton";


import { LINK_PLAY_STORE }                    from "../Utils/Strings/URL";
import { LABEL_DownloadNow, LABEL_SignInNow } from "../Utils/Strings/Labels";
import * as PAGESSWITCH                       from "../Utils/PagesSwitch.js";
import * as ROUTE                             from "../Utils/Strings/Route";
import { LABEL_Login, LABEL_Cancel, LABEL_DIALOG_CONTENT_RecoverPassword, LABEL_SignIn, LABEL_PasswordRecovery, LABEL_Email, LABEL_Required,
         LABEL_Enter_Username, LABEL_ForgotPassword, LABEL_Username, LABEL_Enter_Email, LABEL_Send, LABEL_PAGE_HOME_Videos, LABEL_PAGE_HOME_WhatIs,
         LABEL_Enter_Password, LABEL_Password, LABEL_PAGE_HOME_Bilapp, LABEL_PAGE_HOME_Versions, LABEL_PAGE_HOME_Images, LABEL_PAGE_HOME_Portal   } from "../Utils/Strings/Labels"

/*
    In input una lista di argomenti 
    {
        titolo : ,
        contenuto : ,
    }
*/
export default class ExplanationPage extends Component {

  render() {

    return(
        <div className="ex_container clearfix">
            <div className="ex-pages-container">
                <div className="ex-pages">
                    <div className="ex-title">{"Che cos'è BilApp?"}</div>
                    
                    <Grid>
                        <Row>
                            <Col xs4={4} sm12={4}>
                                <div className="ex-img-centered ex-fit-content">
                                    <img src={LogoBilapp}/>
                                </div>
                            </Col>
                            <Col xs4={4} sm12={8}><div className="ex-body">{"BilApp nasce dall'esigenza di rendere smart la gestione dei terminali bilanciai. Attraverso pochi e semplici passaggi sarai in grado fin da subito di gestire il tuo terminale da qualsiasi punto della tua azienda! Con la nostra applicazione potrai creare delle pesate personalizzabili, con la possibilità di scelta di campi da tabelle appositamente create dal tuo smartphone o da questo portale. Le pesate sono richiamabili tramite un numero univoco dando la possibilità di avere una pesata formata da primo peso, secondo peso e, quindi, da un netto (formato sempre dal valore assoluto)."}</div></Col>
                        </Row>    
                    </Grid>    
                    
                </div>

                <div className="ex-pages">
                    <div className="ex-title"><a name="primo">{"Versioni"}</a></div>
                    <div className="ex-body">
                        {"Vi offriamo tre versioni della BilApp."}
                        <ul>
                            <li>Bilapp Free</li>
                            <li>Bilapp Pro</li>
                            <li>Bilapp Cloud</li>
                        </ul>
                        {"Puoi scegliere la versione piu adatta alle tue esigenze nella pagina di confronto cliccando "}<a onClick={() => this.props.RenderPage(LABEL_PAGE_HOME_Versions[this.props.Language])}>QUI</a>
                        
                    </div>
                </div>

                <div className="ex-pages">
                    <div className="ex-title"><a name="primo">{"Requisiti"}</a></div>
                    <div className="ex-body">
                        {"Per iniziare a lavorare fin da subito con BilApp è necessario avere i seguenti requisiti:"}
                        <Grid>
                            <Row>
                                <Col xs4={4} sm12={8}>
                                    <ul>
                                        <li>Una rete wifi alla quale agganciare il vostro smartphone</li>
                                        <li>Mettere in rete il vostro terminale della Coop. Bilanciai</li>
                                        <li>Assicurarsi che il terminale sia collegato alla stessa rete a cui è connesso il cellulare</li>
                                    </ul>
                                </Col>
                                <Col xs4={4} sm12={4}>
                                    <div className="ex-img-centered ex-fit-content">
                                        <img src={LogoBilappe} style={{width: "100%", height: "100%"}}/>
                                    </div>
                                </Col>
                            </Row>    
                        </Grid>  
                    </div>
                    
                </div>

                

                <div className="ex-pages">
                    <div className="ex-title">
                        {"Portale Web"}
                    </div>
                    <div className="ex-body">
                        Il portale web e' stato pensato per dare la possibilita di amministrare il proprio account e avere la possibilita' vedere i propri dati in tempo reale.
                        <FlatButton
                          className="btn-bottom"
                          label={"Portale"}
                          fullWidth={true}
                          style={{marginTop: "20px"}}
                          onClick={() => this.props.RenderPage(LABEL_PAGE_HOME_Portal[this.props.Language])} />
                    </div>
                </div>

                

                
                

            </div>

            
        </div>
    );

  }

}




// WEBPACK FOOTER //
// ./src/Components/component_ExplanationPage.js